import { render, staticRenderFns } from "./InfomationDialog.vue?vue&type=template&id=fb65ae78&"
import script from "./InfomationDialog.vue?vue&type=script&lang=ts&"
export * from "./InfomationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports